import { getProductFormField } from '../utils';
import Component from './ProductFormDateFields';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
